<template>
    <Toast/>
    <div v-if="$can('view','cruise_line')" class="pt-4 pb-2">
        <div class="flex justify-content-between align-items-end">
            <h1 class="my-auto"> Cruise Lines </h1>
            <div v-if="$can('add','cruise_line')" class="card p-1">
                <Button data-cy="new_cruile_line_button" class="p-button-text p-button-success" @click="openModal" v-tooltip.bottom="'New Cruise Line'">
                    <i class="pi pi-plus" style="font-size: 1.5rem" ></i>
                </Button>
            </div>
        </div>

        <Dialog data-cy="new_cruise_line_modal" header="New Cruise Line" v-model:visible="displayModal" :modal="true" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}">
            <form id="form_new_cruise_line" @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
                <div class="container">
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <InputText id="name" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted || cruise_line_errors.name}" />
                                <label for="name" :class="{'p-error':v$.name.$invalid && submitted}"> Name* </label>
                                <small v-if="Object.keys(cruise_line_errors).length !== 0 && cruise_line_errors.name" class="p-error"><span v-for="error in cruise_line_errors.name" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>        
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <Dropdown data-cy="group_dropdown" id="id_group" v-model="v$.id_group.$model" :options="all_groups" optionLabel="name" :filter="true" :class="{'p-invalid':v$.id_group.$invalid && submitted || cruise_line_errors.id_group}"/>
                                <label for="id_group" :class="{'p-error':v$.id_group.$invalid && submitted || cruise_line_errors.id_group}"> Group* </label>
                                <small v-if="Object.keys(cruise_line_errors).length !== 0 && cruise_line_errors.id_group" class="p-error"><span v-for="error in cruise_line_errors.id_group" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.id_group.$invalid && submitted) || v$.id_group.$pending.$response" class="p-error">{{v$.id_group.required.$message.replace('Value', 'Group')}}</small>
                        </div>
                    </div>
                </div>
            </form>
            <template #footer>
                <Button data-cy="create_cruise_line_button" form="form_new_cruise_line" type="submit" label="Submit" class="p-button-raised"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core"

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Dialog,
        Button,
        InputText,
        Toast,
        Dropdown
    },
    data() {
        return {
            displayModal: false,
            name: '',
            id_group: null,
            cruise_line_errors:{},
            submitted: false,
            showMessage: false,
        }
    },
    computed: {
        get_errors_cruise_line: function() {
            return this.$store.getters.get_errors_cruise_line
        },
        all_groups: function() {
            return this.$store.getters.all_groups
        }
    },
    methods: {
        openModal() {
            this.displayModal = true;
        },
        closeModal() {
            this.displayModal = false;
        },
        async add_cruise_line() {
            let cruise_lines = { 
                name: this.name,
                id_group: this.id_group
            }
            await this.$store.dispatch('create_cruise_line', cruise_lines)
            this.cruise_line_errors = this.get_errors_cruise_line
            if(Object.keys(this.cruise_line_errors).length === 0){
                this.toggleDialog();
                this.name = ''
                return true
            }
            return false
        },
        async handleSubmit(isFormValid) {

            this.submitted = true;
            
            if (!isFormValid) {
                return;
            }

            let res = await this.add_cruise_line()
            if (res){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Cruise line added', life: 3000});
            } 
        },
        toggleDialog() {
            this.showMessage = !this.showMessage;
            this.closeModal()

            if(!this.showMessage) {
                this.resetForm();
            }
        },
        resetForm() {
            this.name = '';
            this.submitted = false;
        }
    },
    validations() {
        return {
            name: { required },
            id_group: { required }
        }
    },
};
</script>

<style scoped>

</style>